var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7175 14.7175C13.0076 18.4275 6.9925 18.4275 3.28252 14.7175C-0.427465 11.0075 -0.427465 4.99247 3.28252 1.28249C3.8683 0.696699 4.81805 0.6967 5.40384 1.28249C5.98962 1.86827 5.98962 2.81802 5.40384 3.40381C2.86543 5.94221 2.86543 10.0578 5.40384 12.5962C7.94224 15.1346 12.0578 15.1346 14.5962 12.5962C17.1346 10.0578 17.1346 5.94221 14.5962 3.40381C14.0104 2.81802 14.0104 1.86827 14.5962 1.28249C15.182 0.696699 16.1318 0.696699 16.7175 1.28249C20.4275 4.99247 20.4275 11.0075 16.7175 14.7175Z",
    fill: "#EDEDED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLoader);
export default __webpack_public_path__ + "static/media/icons_loader.5e9a279516e8124634e1ccaef08b0a7c.svg";
export { ForwardRef as ReactComponent };